<template>
  <div class="sr-list-tile list-tile" @click="onNodeClick" :class="{active}" :id="id">
    <p class="title">
      {{ sr.title }}
    </p>
    <p class="subtitle">
      {{ sr.firstAuthor }} {{ sr.year }}
    </p>
  </div>
</template>
<script lang="ts">
import {defineComponent, inject, PropType, computed} from "vue";
import {INode, ISr, IStudy} from "@/interfaces/evidence-map";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "SrListTile",
  props: {
    sr: {
      type: Object as PropType<ISr>
    },
    active: {
      type: Boolean,
      default: null
    },
    searchMode: {
      type: Boolean,
      default: false
    },
    id : {
      type: String,
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const active = computed(() => props.searchMode?props.active: mapStore.state.sr=== props.sr)
    const onNodeClick = () => {
      mapStore.onSrClick(props.sr)
    }
    return {
      onNodeClick,
      active
    }
  }

})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

.sr-list-tile {

}
</style>
